// extracted by mini-css-extract-plugin
export default {"rating":"RA-z","numberOfStars":"SA-z","count":"TA-z","barGraphSpacing":"UA-z","barGraph":"VA-z"};